import React from 'react';
import { Grid } from '@mui/material';
import { Layout } from '@/containers';
import ItemRoute from '@/pageComponents/Items';

const Services = () => (
    <Layout>
        <Grid container direction="row">
            <Grid item xs={12}>
                <ItemRoute pathname="/items/services" />
            </Grid>
        </Grid>
    </Layout>
);

export default Services;
